import { useEffect, useState } from "react";

interface CommittedPastDays {
  /** チェック可否の判定に使う経過日数。入力欄にフォーカスがある間は更新しない */
  committedPastDays: number;
  /** 経過日数の入力欄を包む要素に渡すフォーカス監視 */
  pastDaysFocusProps: {
    onFocus: () => void;
    onBlur: () => void;
  };
}

/**
 * 経過日数の確定値を返す。
 * 打鍵ごとに判定すると「30 を消して 7 を打つ」途中の 0 で窓外と判定され、
 * リユース系のチェックが戻せない形で解除されるため、入力中は判定用の値を止める。
 */
export const useCommittedPastDays = (pastDays: number): CommittedPastDays => {
  const [isEditing, setIsEditing] = useState(false);
  const [committedPastDays, setCommittedPastDays] = useState(pastDays);

  useEffect(() => {
    if (!isEditing) {
      setCommittedPastDays(pastDays);
    }
  }, [isEditing, pastDays]);

  return {
    committedPastDays,
    pastDaysFocusProps: {
      onFocus: () => {
        setIsEditing(true);
      },
      onBlur: () => {
        setIsEditing(false);
      },
    },
  };
};
